import DropdownSelect from "./DropdownSelect/DropdownSelect";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "./CustomDatePicker/CustomDatePicker";
import MultipleSelect from "./MultipleSelect/MultipleSelect";
import { CustomMultipleInput } from "./CustomMultipleInput/CustomMultipleInput";
import { Input, TextField } from "@mui/material";
import { Checkbox } from '@mui/material';
import { PropConfig } from "../../types/EntityConfig";
import { useFormType } from "../hooks/useForm";
import { optionCSS } from "react-select/dist/declarations/src/components/Option";
import { FileUploader } from "../../components/FileUploader";
import { useEffect, useState } from "react";
import AttachmentIcon from '@mui/icons-material/Attachment';


type CIInputType = {
    inputConfiguration: PropConfig,
    form?: useFormType,
    getter?: Function,
    customOnChange?: (e: any) => void,
    filterMode?: boolean,
    hiddenLabel?: boolean,
    isSubForm?: boolean,
    valueGetter?: any // Particular case for CustomMultipleInput
    parentIndex?: number // Particular case for CustomMultipleInput
}





export const CustomInput = ({
    inputConfiguration,
    form,
    customOnChange,
    getter,
    hiddenLabel,
    filterMode,
    parentIndex,
    valueGetter
}: CIInputType) => {


    // if(inputConfiguration.type === 'select') console.log("Got value: ", form.state)
    const [anexos, setAnexos] = useState<File[]>([]);


    const getValue = (def?: any) => {
        let v;
        if (valueGetter) {
            v = valueGetter();
        } else {
            v = form?.state ? form.state[inputConfiguration.id] : (def ? def : null)
        }
        return v;
    }

    const onChange = customOnChange ? customOnChange : (e: any) => {
        form?.update(e, inputConfiguration.id, inputConfiguration.type, inputConfiguration.separateValueUpdateOptions)
    }


    const getLabelPrefix = () => {
        const type: PropConfig['type'] = inputConfiguration.type;
        if (type == 'select' || type == 'multi-select' || type == "enum" || type == "date")
            return 'Seleccione';
        if (type == 'number' || type == 'text' || type == "percentage" || type == "multiple-create")
            return 'Introduza';

    }

    useEffect(()=> {
        console.log("FOrm state: ", form?.state)
    },[form?.state])


    const getInputType = () => {
        const type = inputConfiguration.type;
        switch (type) {
            case 'boolean':
                return <Checkbox
                    onChange={onChange}
                    checked={getValue(false)} />
            case 'select':
                return <DropdownSelect
                    inputConfiguration={inputConfiguration}
                    onChange={onChange}
                    value={getValue()}
                    getter={getter}
                    formData={form?.state}
                />
            case 'multi-select':
                return <MultipleSelect
                    formData={form?.state}
                    getter={getter}
                    value={getValue([])}
                    onChange={onChange}
                    options={inputConfiguration.options}
                />
            case 'enum':
                return <DropdownSelect
                    inputConfiguration={inputConfiguration}
                    getter={getter}
                    value={getValue()}
                    onChange={onChange}
                    formData={form?.state}

                />
            case 'date':
                return <CustomDatePicker
                    label={inputConfiguration.label}
                    key={inputConfiguration.id}
                    value={getValue(new Date())}
                    onChange={onChange}
                />
            case 'multiple-create':
                return <CustomMultipleInput
                    label={inputConfiguration.label}
                    value={getValue()}
                    onChange={onChange}
                    inputConfig={inputConfiguration}
                    form={form}
                    key={inputConfiguration.id}
                    parentIndex={parentIndex}
                />
            case 'anexos':
                return <FileUploader
                    form={{
                        setFieldValue: (name, value)=> onChange(value)
                    }}
                    field={{
                        name: inputConfiguration.id,
                        value: form?.state[inputConfiguration.id]
                    }}
                    title={`${inputConfiguration.label}`}
                    icon={<AttachmentIcon style={{ fontSize: '2.5em' }} />}
                />
            default:
                return <TextField
                    label={`${inputConfiguration.label}`}
                    variant={'outlined'}
                    style={{ width: '100%' }}
                    onChange={onChange}
                    value={getValue()}
                    type={type}
                    lang="en-US"
                    multiline={inputConfiguration.options?.isMultiLine}
                    onWheel={() => (document as any)?.activeElement?.blur()}
                />
        }
    }




    return (<div className="p-2 pb-4 text-xs">
        {!hiddenLabel ?
            <label
                className={`${filterMode ? '' : 'text-[1em]'}`}
                style={filterMode ? { marginRight: '20px' } : { fontWeight: 'bold', marginRight: '20px' }}>
                {getLabelPrefix()} {inputConfiguration.label}
            </label>
            : null}


        <div className="w-full mt-3">
            {getInputType()}
        </div>
    </div>)

}